import { Tag } from '..';
import type { TTagProps } from '../types/TProps';

export const TagDefaultRounded = ({ className = '', ...props }: TTagProps) => (
  <Tag {...props} className={['tag--default-rounded', className].filter(Boolean).join(' ')} />
);
